import { hexToEditorBackgroundPaletteColor } from '@atlaskit/editor-palette/background';
import { hexToEditorTextPaletteColor } from '@atlaskit/editor-palette/text';
import { token } from '@atlaskit/tokens';

import { maybeConvertToHex } from '@atlassian/color-picker/utils/rgb-to-hex';

const customTextColors = {
	'#0000FF': token('color.link'),
	'#7A869A': token('color.text.subtlest'),
	'#808080': token('color.text.subtlest'),
	'#1D1C1D': token('color.text'),
	'#000000': token('color.text'),
};

const getTextColor = (color: string): string | undefined => {
	const paletteColor = hexToEditorTextPaletteColor(color);
	if (paletteColor) {
		return paletteColor;
	}

	return customTextColors[color];
};

type CSSColorProperty = 'background-color' | 'color';

const replaceColor = (
	oldColor: string,
	newColor: string | undefined,
	cssProperty: CSSColorProperty,
	html: string,
): string => {
	if (!newColor) {
		return html;
	}

	const stringToMatch = `${cssProperty}: ${oldColor}`;
	const stringToReplace = `${cssProperty}: ${newColor}`;
	return html.replaceAll(stringToMatch, stringToReplace);
};

// @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
const styleAttributeRegex = /style=".*?"/gis;
const colorRegex =
	// @ts-expect-error - TS1503, TS1503, TS1501 Typescript 5.9.2 upgrade
	/(?<cssProperty>background-color|color): (?<cssValue>rgb\(\d+,\d+,\d+\)|#[A-F0-9]{3,6});?/gis;

export const tokenizeColors = (welcomeMessageHtml: string): string => {
	const backgroundColors = new Set<string>();
	const textColors = new Set<string>();

	const styleTags = welcomeMessageHtml.matchAll(styleAttributeRegex);
	for (const styleTag of styleTags) {
		const colorDeclarations = styleTag[0].matchAll(colorRegex);
		for (const colorDeclaration of colorDeclarations) {
			const cssProperty = colorDeclaration.groups?.cssProperty;
			const cssValue = colorDeclaration.groups?.cssValue;

			if (cssValue && cssProperty === 'background-color') {
				backgroundColors.add(cssValue);
			} else if (cssValue && cssProperty === 'color') {
				textColors.add(cssValue);
			}
		}
	}

	backgroundColors.forEach((backgroundColor: string) => {
		const hexColor = maybeConvertToHex(backgroundColor);
		const newColor = hexToEditorBackgroundPaletteColor(hexColor);
		welcomeMessageHtml = replaceColor(
			backgroundColor,
			newColor,
			'background-color',
			welcomeMessageHtml,
		);
	});

	textColors.forEach((textColor: string) => {
		const hexColor = maybeConvertToHex(textColor);
		const newColor = getTextColor(hexColor);
		welcomeMessageHtml = replaceColor(textColor, newColor, 'color', welcomeMessageHtml);
	});

	return welcomeMessageHtml;
};
